import { useStore as useOriginalStore } from 'react-redux';
import { AnyAction, Store } from 'redux';
import { RootState } from '../reducers';

export const useStore = useOriginalStore as () => Store<RootState, AnyAction>;
